// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const ADMIN_ROUTE_PREFIX = '/admin';
